import { render, staticRenderFns } from "./UpdatePlayer.vue?vue&type=template&id=32c239a0"
import script from "./UpdatePlayer.vue?vue&type=script&lang=js"
export * from "./UpdatePlayer.vue?vue&type=script&lang=js"
import style0 from "./UpdatePlayer.vue?vue&type=style&index=0&id=32c239a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports